import _ from './menu-item.module.scss'
import React from 'react'
import {$, $$$} from '../shared/class-name'

export const MenuItem = ({
    children,
    onClick,
    onMouseOver,
    onMouseOut,
    className,
    title,
    active,
    highlighted,
    disabled,
    secondary,
    secondaryActive,
    variant,
    index,
    wide,
    stretchMode,
    safeAreaHandling,
    activeBackground,
    submenu,
    toolbar,
    white,
    smallPadding,
    fixedSize,
}) => {
    return <span
        onClick={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        title={title}
        data-variant={variant}
        style={active && activeBackground ? {backgroundColor: activeBackground} : undefined}
        className={$$$(
            $(_.menuItem),
            $(className),
            $(_.active, active),
            $(_.submenu, submenu),
            $(_.highlighted, highlighted),
            $(_.disabled, disabled),
            $(_.secondary, secondary),
            $(_.secondaryActive, secondaryActive),
            $(_.toolbar, toolbar),
            $(_.white, white),
            $(_.wide, stretchMode && wide),
            $(_.stretch, stretchMode && !wide),
            $(_.safeAreaHandling, safeAreaHandling),
            $(_.smallPadding, smallPadding),
            $(_.feed, variant === 'feed'),
            $(_.menu999, variant === '999'),
            $(_.worldwide, variant === 'outof195'),
            $(_.void, variant === 'void'),
            $(_.soundcloud, variant === 'soundcloud'),
            $(_.instagram, variant === 'instagram'),
            $(_.spotify, variant === 'spotify'),
            $(_.autoscroll, variant === 'autoscroll'),
            $(_.fixedSize, fixedSize),
            $(_[`index${index}`], index !== undefined),
        )}>{typeof children === 'string'
        ? children.split(' ').map((element, idx) => <div className={_.content} key={idx}>{element}</div>)
        : children}</span>;
}
